import api from '@/api'
import _ from 'lodash'

function getFieldsToTranslate(rev) {
  // This method is apparently duplicated in another action, but if you look carefully the fields to be translated are not the same, we do this because each word that is translated costs money and we do not want to waste resources
  const fieldsToTranslate = [
    'name',
    'problemAnalysis.businessRequirements',
    'problemAnalysis.containment',
    'problemAnalysis.goals',
    'problemAnalysis.measureDescription',
    'problemAnalysis.problem',
    'reviewPhase.estimationExplanation',
    'solutionDescription',
  ]

  rev?.rootCauses?.forEach?.((rootCause, i) => {
    fieldsToTranslate.push(
      `rootCauses[${i}].correctiveAction`,
      `rootCauses[${i}].correctiveLearning`,
      `rootCauses[${i}].description`,
      `rootCauses[${i}].name`,
      `rootCauses[${i}].preventiveAction`
    )
  })

  return fieldsToTranslate
}

export default {
  getRev(context, payload) {
    return api.problemsolving
      .getById(payload.organizationId, payload.revId)
      .then(({ data: rev }) => {
        context.commit('SET_REV', { rev })
        return rev
      })
  },

  async getRevChallenge(context, { organizationId, revId }) {
    const challengeResponse = await api.challenge.getChallengesFromRev(
      'problem-solving',
      organizationId,
      revId
    )
    const challenge = challengeResponse.data?.[0] ?? null
    context.commit('SET_CHALLENGE', {
      challenge: {
        name: challenge?.name ?? '',
      },
    })

    return challenge
  },

  async translateRev(context, { organizationId, revId, targetLanguage }) {
    const { data: rev } = await api.problemsolving.getById(
      organizationId,
      revId
    )
    const fieldsToTranslate = getFieldsToTranslate(rev)
    const translatedRev = Object.assign({}, rev)

    for (const field of fieldsToTranslate) {
      if (!_.get(rev, field)) continue
      const translatedField = await api.translate.text(
        organizationId,
        _.get(rev, field),
        targetLanguage
      )
      _.set(translatedRev, field, translatedField.data.translatedText)
    }

    context.commit('SET_REV', { rev: translatedRev })

    return translatedRev
  },
}
